import { GlobalModalAndDrawerPayload } from '../types';
import { GlobalModalAndDrawer } from './GlobalModalAndDrawer';

export class GlobalDrawer extends GlobalModalAndDrawer {
  constructor({ name, data }: GlobalModalAndDrawerPayload) {
    super({ type: 'drawer', name, data });
  }
}
